import jwt_decode from 'jwt-decode';
import { storageConstant } from '../constants/storage.constant';
import { UserRole } from '../types/userRole.types';
import { UserPermissions } from '../types/userPermissions.types';

export const getUserRolesByToken = () => {
  const accessToken = localStorage.getItem(storageConstant.ACCESS_TOKEN);
  const decodedAccessToken: any = decodeToken(accessToken);
  const roles = decodedAccessToken?.resource_access?.hunter?.roles;
  return Array.isArray(roles) && roles.length
    ? roles.filter(role =>
        Object.values(UserRole).some(userRole => userRole === role),
      )
    : [];
};

const decodeToken = (token: string | null) => {
  if (!token) return null;

  try {
    return jwt_decode(token);
  } catch (error) {
    return null;
  }
};

export const checkUserRequiredRole = (
  userRoles: { id: number; name: UserRole }[] = [],
  requiredRole: UserRole[] = [],
) => {
  const userRolesNames = userRoles.map(role=> role.name)
  return userRolesNames.some(userRole => requiredRole.includes(userRole));
};

export const checkUserRequiredPermissions = (
  userPermissions: { id: number; name: UserPermissions }[] = [],
  requiredPermission: UserPermissions[] = [],
) => {
  const userRolesNames = userPermissions.map(role => role.name);
  return requiredPermission.every(permission =>
    userRolesNames.includes(permission),
  );
};
